import React, { useState } from 'react';

import * as css from './index.module.css';

import open  from './img/hamburger.svg';
import close from './img/close.svg';
import gw2   from '../img/gw2-logotype.svg';

import Link from '../link';

import { i18n } from '../../i18n';

// todo:
// - remove download link?
// - add lang select
// - add anet logo

function BtnLink({ title, url, childs, setSubNav, setParent }) {
    return childs ?
        <button
            onClick={() => {
                setSubNav(childs);
                setParent({ title, url });
            }}
            dangerouslySetInnerHTML={{ __html : title }}
            className={css.btn}
        /> :

        <Link url={url} title={title} className={css.link} />;
}

function Parent({ title, url }) {
    return <Link url={url} title={title} className={css.parent}/>;
}

function Back({ back }) {
    return <button className={css.backBtn} onClick={back}>
        {i18n('ui.back')}
    </button>;
}

function SubSubNav({ nav, data, back, parent }) {
    return <div className={ css.subSubNav }>

        <Back back={back} />

        <Parent url={parent.url} title={parent.title}/>

        <ul>
            {nav.map(({ id }) =>
                <li key={id}>
                    <BtnLink url={data[id].url} title={ data[id].title }/>
                </li>
            )}
        </ul>
    </div>;
}


function SubNav({ nav, data, back, parent }) {
    const [ subSubNav, setSubSubNav ]   = useState();
    const [ thisParent, setThisParent ] = useState();

    return <div className={ css.subNav }>

        <Back back={back} />

        <Parent url={parent.url} title={parent.title}/>

        <ul>
            {nav.map(({ id, children : childs }) =>
                <li key={id}>
                    <BtnLink
                        title={data[id].title}
                        url={data[id].url}
                        childs={childs} // children is a reserved prop
                        setSubNav={setSubSubNav}
                        setParent={setThisParent} />
                </li>
            )}
        </ul>

        {subSubNav ? <SubSubNav data={data} nav={subSubNav} back={() => setSubSubNav(false)} parent={thisParent} /> : null}

    </div>;
}

export default function Nav({ nav }) {
    const [ navOpen, setNavOpen ]       = useState();
    const [ subNav, setSubNav ]         = useState();
    const [ thisParent, setThisParent ] = useState();

    return <>
        <button className={ css.navBtn } onClick={() => setNavOpen(true)}>
            <img src={open} alt={i18n('ui.open', { md : false })} />
        </button>

        {
            navOpen ?
                <div className={ css.navOpen }>

                    <img className={ css.gw2Logo } src={gw2} alt='Guild Wars 2' />

                    <button className={ css.closeBtn } onClick={() => {
                        setNavOpen(false);
                    }}>
                        <img src={close} alt={i18n('ui.close', { md : false })} />
                    </button>

                    <ul>
                        {nav.format.map(({ id, children : childs }) =>
                            <li key={id}>
                                <BtnLink
                                    title={nav.data[id].title}
                                    url={nav.data[id].url}
                                    childs={childs} // children is a reserved prop
                                    setSubNav={setSubNav}
                                    setParent={setThisParent} />
                            </li>
                        )}
                    </ul>

                    {subNav ? <SubNav data={nav.data} nav={subNav} back={() => setSubNav(false)} parent={thisParent} /> : null}

                </div> :
                null
        }
    </>;
}
